export {default as lang} from './en-US';
